import styled from "styled-components";

export const Row = styled.td`
  cursor: pointer;
`;
